import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import TireAttributeIcon from './components/tire-attribute-icon/tire-attribute-icon';

import { TIRE_ATTRIBUTE_ICON_DESCRIPTION } from '../../shared/constants/products';

import './tire-attribute-icons.scss';

interface TireAttributeIconsProps {
  className?: string;
  hideTitle?: boolean;
  icons?: string[];
}

function TireAttributeIcons(props: TireAttributeIconsProps) {
  const { className, icons, hideTitle = false } = props;

  if (!(Array.isArray(icons) && icons.length > 0)) {
    return null;
  }

  return (
    <span className={`tire-attribute-icons ${className}`} styleName="container">
      {!hideTitle && (
        <Typography tag="span" weight="black">
          Features
        </Typography>
      )}

      {icons.map((icon, i) => {
        if (!TIRE_ATTRIBUTE_ICON_DESCRIPTION[icon]) return null;
        return (
          <Tooltip
            content={TIRE_ATTRIBUTE_ICON_DESCRIPTION[icon].description}
            hoverOver
            key={`tire-icon-tooltip-${i}`}
            render={() => (
              <div styleName="icon-container">
                <TireAttributeIcon name={icon} />
              </div>
            )}
            styleName="tooltip"
          />
        );
      })}
    </span>
  );
}

export default TireAttributeIcons;
